export default "__VITE_ASSET__ChLkPsIs__"